<template>
  <div class="drawer">
    <el-drawer
      size="720px"
      title=""
      :visible.sync="drawerStatus"
      @close="close"
    >
      <div class="content">
        <div class="contentBtns">
          <div style="line-height: 32px">房间详情</div>
          <div>
            <el-button type="warning" plain size="small" @click="joinCage"
              >入住</el-button
            >
            <el-button type="warning" plain size="small" @click="qrcode(cageInfo)"
              >二维码</el-button
            >
            <el-button
              type="warning"
              plain
              size="small"
              @click="editCage"
              :disabled="cageInfo.status.value == '9'"
              v-show="$buttonAuthority('huoti-pethouse-editcage')"
              >编辑</el-button
            >
            <el-button
            v-show="$buttonAuthority('huoti-pethouse-delcage')"
              type="warning"
              plain
              size="small"
              @click="delCage"
              :disabled="cageInfo.status.value == '9'"
              >删除</el-button
            >
          </div>
        </div>
        <div class="cagedetail">
          <div>
            <span style="#979797">门店: </span>
            {{ $public.getShopNameById(cageInfo.shopId) }}店
          </div>
          <div>区域: {{ cageInfo.cageArea.title }}</div>
          <div>位置: {{ cageInfo.positionName }}</div>
          <div>房号: {{ cageInfo.cageName }}</div>
          <div>状态: {{ cageInfo.status.title }}</div>
        </div>
        <div class="conView">
          <div
            class="conItem"
            :class="type == 0 ? 'active' : ''"
            @click="type = 0"
          >
            房间宠物
          </div>
          <div
            class="conItem"
            :class="type == 1 ? 'active' : ''"
            @click="type = 1"
          >
            日志记录
          </div>
        </div>
        <div
          v-show="!cageInfo.pets.length && type == 0"
          style="font-weight: 600"
        >
          暂无宠物信息
        </div>
        <div
          v-show="type == 0"
          class="viewItem"
          style="margin-bottom: 10px"
          v-for="item in cageInfoD.pets"
          :key="item.id"
        >
          <div class="imgView">
            <img :src="item.cover" alt="" class="imgView" v-if="item.cover" />
            <img src="../../../../assets/img/cat.png" alt="" v-if="!item.cover&&item.isMemberPet==1&&item.petType=='1'">
            <img src="../../../../assets/img/dog.png" alt="" v-if="!item.cover&&item.isMemberPet==1&&item.petType=='2'">
          </div>
          <div>
            <div style="display: flex">
              <div style="font-weight: 600; color: #333336">
                {{ item.insideName }}
              </div>
            </div>
            <div class="cont">
              <span>{{ item.age }}</span>
              <span>{{ item.sex }}</span>
              <span v-if="item.saleStatus" :class="item.saleStatus.value == '9' ? 'saleClass' : ''">{{
                item.saleStatus.title
              }}</span>
            </div>
            <div class="cont" v-if="item.isMemberPet==0">芯片:{{ item.epromNo }}</div>
            <div class="cont" v-if="item.isMemberPet==0">脖圈:{{ item.insideNo }}</div>
            <div class="cont" v-if="item.isMemberPet==1">主人姓名:{{ item.memberName }}</div>
            <div class="cont" v-if="item.isMemberPet==1">主人手机号:{{ item.memberMobile }}</div>
            <div class="cont" v-if="item.isMemberPet==1">编号:{{ item.linkNum }}</div>
            <div class="cont">
              <div>入住:{{ $public.FTime(item.joinTime, "YYYY-MM-DD") }}</div>
            </div>
            <div
              style="
                cursor: pointer;
                display: flex;
                justify-content: space-between;
              "
            >
              <div style="color: #577bff" @click="changeCage(item.petId,item)">
                更换房间
              </div>
              <div v-if="item.isMemberPet==0" @click="morePetInfo(item.petId)">更多</div>
            </div>
          </div>
        </div>
        <div v-show="type == 1">
          <el-form class="searchBox">
            <el-row>
              <el-col :span="2">
                <el-form-item label="类型" :label-width="'50px'">
                  <el-select
                    style="width: 100px"
                    class="select"
                    v-model="operTypeId"
                    placeholder="请选择"
                    size="small"
                    @change="clickSearch"
                  >
                    <el-option
                      v-for="item in [
                        { label: '入住', value: '2' },
                        { label: '移出', value: '3' },
                        { label: '创建', value: '1' },
                        {
                          label: '更新状态',
                          value: '4',
                        },
                      ]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="时间" :label-width="'150px'">
                  <el-date-picker
                    type="daterange"
                    v-model="timer"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    size="small"
                    style="width: 220px"
                    @change="clickSearch"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item :label-width="'80px'">
                  <resetBtn
                    @reset="reset"
                    style="margin-left: 150px"
                  ></resetBtn>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-table :data="operatList" style="width: 100%">
            <el-table-column prop="cageOperType" label="操作类型">
              <template slot-scope="scope">
                <div v-if="scope.row.cageOperType">
                  {{
                    scope.row.cageOperType ? scope.row.cageOperType.title : "--"
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="时间">
              <template slot-scope="scope">
                {{ $public.FTime(scope.row.operTime) }}
              </template>
            </el-table-column>
            <el-table-column label="操作人" prop="operUser">
              <template slot-scope="scope">
                {{ scope.row.operUser || "--" }}
              </template>
            </el-table-column>
            <el-table-column label="操作目的地" prop="content">
            </el-table-column>
          </el-table>
          <page
            :page="page.page"
            :total="page.total"
            @change="pageChange"
            style="padding: 12px 0"
          ></page>
        </div>
        <!-- 二维码 -->
        <el-dialog
          title="宠物笼位二维码"
          :visible.sync="dialogVisible"
          width="38%"
          :modal-append-to-body="false"
          :before-close="handleClose"
          center
        >
          
              <img
                :src="qrImgUrl"
                alt=""
                style="width: 100%; height: 100%;"
              />
          
          <span slot="footer" class="dialog-footer">
            <el-button type="warning" @click="downloadQrImg(cageInfo)">下载</el-button>
          </span>
        </el-dialog>
        <!-- 删除 -->
        <el-dialog
          title="操作确认"
          :visible.sync="dialogdelVisible"
          width="20%"
          :modal-append-to-body="false"
          :before-close="handleClose"
          center
        >
          <span>是否确认删除</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="drawerStatus = false">取 消</el-button>
            <el-button type="warning" @click="deleteCage">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 编辑 -->
        <el-dialog
          title="编辑房子"
          :visible.sync="dialogCageType"
          width="30%"
          :modal-append-to-body="false"
          :before-close="handleClose"
        >
          <el-form :model="form" label-width="80px">
            <el-form-item label="区域">
              <el-select
                v-model="form.cageArea.value"
                placeholder="请选择"
                @change="changeArea"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select> </el-form-item
            ><el-form-item label="位置">
              <el-select v-model="form.positionName" placeholder="请选择">
                <el-option
                  v-for="item in positionList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                >
                </el-option>
              </el-select> </el-form-item
            ><el-form-item label="笼号">
              <div>{{ form.cageId }}</div>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="form.status.title">
                <el-option label="空" value="0"></el-option>
                <el-option label="维修" value="1"></el-option>
                <el-option label="锁定" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="名称">
              <el-input v-model="form.cageName" style="width: 217px"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="warning" @click="changeCageType">确 定</el-button>
            <el-button @click="drawerStatus = false">取 消</el-button>
          </span>
        </el-dialog>
        <!-- 宠物入住 -->
        <el-dialog
          title="宠物入住"
          :visible.sync="dialogJoinCage"
          width="30%"
          :modal-append-to-body="false"
          :before-close="handleClose"
          center
        >
          <div>
            <el-input
              v-model="search"
              placeholder="芯片号/脖圈号/宠物名称"
              clearable
              prefix-icon="el-icon-search"
              style="width: 150px; margin-right: 10px"
              @keyup.enter.native="handelSearchClick"
            ></el-input>
            <el-button type="warning" @click="handelSearchClick"
              >搜索</el-button
            >
          </div>
          <div class="petInfo" v-if="pet !== null">
            <div>
              品种:
              <span style="color: black">
                {{
                  pet == null || pet.breedInfo == null
                    ? "--"
                    : pet.breedInfo.name
                }}
              </span>
            </div>
            <div>
              性别：
              <span style="color: black">
                {{ pet == null ? "--" : pet.petSex }}
              </span>
            </div>
            <div>
              年龄：
              <span style="color: black">
                {{ pet == null ? "--" : pet.age }}
              </span>
            </div>
            <div>
              芯片：
              <span style="color: black">
                {{ pet == null ? "--" : pet.epromNo }}
              </span>
            </div>
            <div>
              脖圈号：
              <span style="color: black">
                {{ pet == null ? "--" : pet.insideNo }}
              </span>
            </div>
            <!-- <div>位置:</div> -->
          </div>

          <span slot="footer" class="dialog-footer">
            <el-button @click="drawerStatus = false">取 消</el-button>
            <el-button type="warning" @click="petJionCage">入住</el-button>
          </span>
        </el-dialog>
      </div>
      <!-- 宠物更换房子 -->
      <div v-if="petCageState">
        <drawerPetCage
          :petId="petId"
          :receiveShopId="cageInfo.shopId"
          @submit="submit_drawerStatus"
        ></drawerPetCage>
      </div>
      <div v-if="petZhuyuanCageState">
        <drawerZhuyuanPetCage
          :petId="petId"
		  :type="type"
		  :apply_type="apply_type"
          @submit="submit_drawerZhuyuanStatus"
        ></drawerZhuyuanPetCage>
      </div>
      <div v-if="petJiYangCageState">
        <drawerJiYangPetCage
          :petId="petId"
		     :type="type"
		     :apply_type="apply_type"
          @submit="submit_drawerJiYangStatus"
        ></drawerJiYangPetCage>
      </div>
    </el-drawer>
  </div>
</template>
    
    <script>
    import drawerJiYangPetCage from "../../../../components/drawerPetCage/drawer_JiYangPetCage.vue";
    import drawerZhuyuanPetCage from "../../../../components/drawerPetCage/drawer_ZhuyuanPetCage.vue";
import axios from "axios";
import { keyword } from "@/api/purchaseApi.js";
import page from "../../../../components/page.vue";
import resetBtn from "../../../../components/resetBtn.vue";
import drawerPetCage from "../../../../components/drawerPetCage/drawer_petCage.vue";
export default {
  components: {
    drawerPetCage,
    resetBtn,
    page,
    drawerZhuyuanPetCage,
    drawerJiYangPetCage
  },
  props: {
    cageInfo: {
      default: () => {
        return {};
      },
    },
    cageId:{
      default:''
    }
  },
  data() {
    return {
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      operTypeId: "",
      timer: [],
      type: "0",
      areaId: "",
      petId: "",
      dialogdelVisible: false,
      petCageState: false,
      drawerStatus: false,
      dialogVisible: false,
      petZhuyuanCageState: false, //顾客宠物 住院更换笼子
      petJiYangCageState:false,//顾客宠物 寄养更换笼子
      //宠物入住
      dialogJoinCage: false,
      //编辑笼子
      dialogCageType: false,
      //搜索宠物
      search: "",
      form: this.cageInfo,
      positionList: [],
      areaList: this.$store.state.areaList,
      pet: null,
      qrImgUrl: "",
      //房子详情
      tableData: [],
      // 操作日志
      operatList: [],
      cageInfoD: [],
      apply_type:''
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.drawerStatus = true;
    });
    
    this.getCageDetail()
    this.getOperatList();
    this.getCageTree();
  },
  methods: {
    // 获取笼子详情
    getCageDetail() {
      let params={
        id: this.cageId
      }
      this.$http
        .get(process.env.VUE_APP_Url_8000 + "/api/cage/info",params)
        .then((res) => {
          if (res.code == 0) {
           this.cageInfoD=res.data
           console.log(this.cageInfoD,"笼子详情");
          }
        });
    },
    // 搜索
    clickSearch() {
      this.page.page = 1;
      this.getOperatList();
    },
    // 重置
    reset() {
      this.timer = [];
      this.operTypeId = "";
      this.page.page = 1;
      this.getOperatList();
    },
    // 页码改变
    pageChange(a) {
      this.page.page = a;
      this.getOperatList();
    },
    // 笼子操作记录
    getOperatList() {
      let params = {
        shopId: this.cageInfo.shopId,
        cageId: this.cageInfo.cageId,
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        operTypeId: this.operTypeId,
      };
      if (this.timer && this.timer.length == 2) {
        params.startTime = ("" + new Date(this.timer[0]).getTime()).substr(
          0,
          10
        );
        params.endTime = ("" + new Date(this.timer[1]).getTime()).substr(0, 10);
      }
      console.log(params);
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_Url_8000 + "/api/cage/oper/record/page",
          params
        )
        .then((res) => {
          loading.close();
          // console.log(res, "日志");
          this.page.total = res.data.count;
          this.operatList = res.data.data;
        });
    },
    // 点击更换房间
    changeCage(id,item) {
      console.log(item,"item");
      this.petId = id;
      console.log(id);
      
      if(item.isMemberPet==1){
        if(item.linkNum.slice(0, 2)=='JY'){
           this.apply_type=item.petType
          this.type='change'
          this.petJiYangCageState = true;
				 }else if(item.linkNum.slice(0, 2)=='ZY'){
          this.apply_type=item.petType
          this.type='change'
          this.petZhuyuanCageState = true;
				 }
        
      }else if(item.isMemberPet==0){
        this.petCageState = true;
      }
      
    },
    submit_drawerJiYangStatus(){
      this.$emit("submit");
    },
    submit_drawerZhuyuanStatus(){
      this.$emit("submit");
    },
    submit_drawerStatus() {
      this.$emit("submit");
    },
    //查看更多
    morePetInfo(id) {
      console.log(id,"id");
      let query = {
        id: id,
      };
      this.$router.push({
        path: "/huotiZongcang/detail",
        query,
      });
    },
    // 下载图片
    downloadQrImg(cageInfo) {
      let a = document.createElement("a");
      a.href = this.qrImgUrl;
      a.download = cageInfo.cageId;
      a.click();
      this.$emit("submit");
    },
    // 获取笼子二维码
    getCageQr() {
      let params = {
        cageId: this.cageInfo.cageId,
      };
      let loading = this.$loading();
      axios
        .get(
          process.env.VUE_APP_Url_8000 + "/api/cage/qr",

          {
            params,
            responseType: "blob",
          }
        )
        .then((response) => {
          loading.close();
          var url = window.URL.createObjectURL(response.data); //创建下载的链接
          this.qrImgUrl = url;
          this.dialogVisible = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 删除笼子
    deleteCage() {
      let loading = this.$loading();
      this.$http
        .delete(process.env.VUE_APP_Url_8000 + "/api/cage/delete", {
          cageId: this.cageInfo.cageId,
        })
        .then((res) => {
          loading.close();
          // console.log(res,'删除');
          this.$emit("submit");
        });
    },
    // 修改笼子状态
    changeCageType() {
      // 锁定
      let loading = this.$loading();
      this.$http
        .post(process.env.VUE_APP_Url_8000 + "/api/update/cage/status", {
          cageId: this.cageInfo.cageId,
          status: this.form.status.title,
        })
        .then((res) => {
          loading.close();
          // console.log(res,'修改状态');
          this.$emit("submit");
        });
    },
    // 编辑笼子状态
    editCage() {
      this.dialogCageType = true;
    },
    // 宠物入住
    petJionCage() {
      if (this.cageInfo.status.value == "1") {
        this.$message({
          type: "error",
          message: "当前房间正在维修",
        });
        return;
      }
      if (this.cageInfo.status.value == "2") {
        this.$message({
          type: "error",
          message: "当前房间已锁定",
        });
        return;
      }
      if (this.$public.isNull(this.pet._id)) {
        this.$message({
          type: "error",
          message: "请选择宠物",
        });
        return;
      }
      let params = {
        petId: this.pet._id,
        cageId: this.cageInfo.cageId,
      };
      let loading = this.$loading();
      this.$http
        .post(process.env.VUE_APP_Url_8000 + "/api/pet/join/cage", params)
        .then((res) => {
          loading.close();
          this.$emit("submit");
        });
    },
    //搜索数据
    handelSearchClick() {
      let that = this;
      let params = {
        keyword: this.search,
      };
      keyword(params).then((res) => {
        if (res.code == 0) {
          that.pet = res.data;
        }
      });
    },
    // 宠物入住
    joinCage() {
      this.dialogJoinCage = true;
    },

    // 区域改变
    changeArea() {
      if (this.form.positionName) {
        this.form.positionName = "";
      }
      let obj = null;
      this.cageData.forEach((item) => {
        if (item.id == this.form.cageArea.value) {
          obj = item;
        }
      });
      console.log(obj);
      this.positionList = obj.children;
    },
    handleClose(done) {
      this.$emit("submit");
    },
    // 获取笼子位置树
    getCageTree() {
      this.$http
        .get(process.env.VUE_APP_Url_8000 + "/api/cage/area/tree", {
          shopId: this.cageInfo.shopId,
        })
        .then((res) => {
          if (res.code == 0) {
            // console.log(res.data, "树");
            this.cageData = res.data;
          }
        });
    },
    // 删除笼子
    delCage() {
      this.dialogdelVisible = true;
    },
    // 二维码
    qrcode() {
      this.getCageQr();
    },
    // 关闭弹框
    close() {
      this.$emit("submit");
    },
  },
};
</script>
    
<style scoped lang="scss">
::v-deep .el-drawer__body {
  overflow-y: auto;
  padding-bottom: 40px;
}
::v-deep .el-dialog {
  border-radius: 16px;
}
.content {
  padding: 20px;

  .contentBtns {
    display: flex;
    justify-content: space-between;
  }
  .cagedetail {
    height: 80px;
    margin: 20px 0px;
    background: $backTextColor;
    border-radius: 16px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .conView {
    display: flex;
    margin-bottom: 10px;
    .conItem {
      cursor: pointer;
      margin-right: 20px;
      padding-bottom: 10px;
    }
    .active {
      border-bottom: 3px solid $mainColor;
    }
  }
  .viewItem {
    padding: 10px;
    width: 60%;
    background: $backTextColor;
    border-radius: 16px;
    font-size: 14px;
    display: flex;
    color: #999999;

    .imgView {
      width: 120px;
      height: 120px;
      border-radius: 8px;
      overflow: hidden;
      margin-right: 10px;
      background-color:#FFCF00;
      img{
        width: 100%;
        height: 100%;
        object-fit:cover;
      }
    }
    .cont {
      margin: 5px 0px;
      .saleClass {
        color: red;
        border: 1px solid red;
      }
      span {
        display: inline-block;
        border: 1px solid #dae2ff;
        font-size: 12px;
        padding: 5px;
        margin: 0px 3px;
        text-align: center;
        color: #495a95;
      }
    }
  }
  .petInfo {
    margin-top: 10px;
    background: #f7f7f7;
    border-radius: 12px;
    width:90%;
    height: 80%;
    padding: 10px;
    div {
      margin: 10px 0px;
      color: #979797;
    }
  }
  .qRcode {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    background: red;
  }
}
</style>